// Role-based UI permissions. The backend is the real source of truth (see
// backend/core/security.py: WAREHOUSE_WRITE_ALLOWED_PREFIXES) — these helpers
// only drive what buttons/forms we show, to avoid a confusing 403 roundtrip.

// Modules the "warehouse" role can create/edit/delete in.
const WAREHOUSE_EDIT_MODULES = ['purchases', 'inventory', 'returns'];

/**
 * Can this user create/edit/delete inside the given module?
 * `module` one of: 'purchases' | 'inventory' | 'returns' | 'skus' | 'sales' |
 * 'retail_pos' | 'sku_aliases' | 'targets' | 'shipment_planning' | 'alerts' |
 * 'excel'. Any module not in WAREHOUSE_EDIT_MODULES is read-only for warehouse.
 */
export const canEditModule = (user, module) => {
  if (!user) return false;
  if (user.role === 'warehouse') return WAREHOUSE_EDIT_MODULES.includes(module);
  return true; // admin & manager keep full edit access everywhere
};

export const isWarehouseRole = (user) => user?.role === 'warehouse';

export const isAdmin = (user) => user?.role === 'admin';

/**
 * Actions the backend allows for admins only, whatever the module:
 *   'data_management' (clear data, fresh start)   backend/routes/data_management.py
 *   'users'                                       backend/routes/users.py
 *   'purchase_post'   (post / reverse / confirm upload)  backend/routes/purchases.py
 *   'sku_alias_delete'                            backend/routes/sku_aliases.py
 *   'sku_rename'                                  backend/routes/skus.py
 * Hide or disable these controls for everyone else and say why.
 */
const ADMIN_ONLY_ACTIONS = ['data_management', 'users', 'purchase_post', 'sku_alias_delete', 'sku_rename'];
export const canDoAdminAction = (user, action) => !ADMIN_ONLY_ACTIONS.includes(action) || isAdmin(user);

/** Short hint for disabled controls, e.g. <Button disabled title={viewOnlyHint(user)}>. */
export const viewOnlyHint = (user) => (
  isWarehouseRole(user)
    ? 'Your role can only edit Purchases, Inventory and Returns.'
    : 'Only admins can do this.'
);
